import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export interface DeleteClaimsRequestParams {
  ClaimKeys: string; // comma-separated claim keys
}

export const deleteClaimsAPI = (params: DeleteClaimsRequestParams) => {
  return axiosInstance.request({
    method: 'delete',
    params,
    url: `${API.LOSS_AND_DAMAGE}/DeleteClaim`,
  });
};

export type DeleteClaimsResponse = void;

export const deleteClaims = async (params: DeleteClaimsRequestParams): Promise<DeleteClaimsResponse> => {
  const response: AxiosResponse<DeleteClaimsResponse> = await deleteClaimsAPI(params);
  return response.data;
};
